import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as ActionCreators from "redux";
import { TextField } from "@material-ui/core";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";

const gmapScriptId = "gmapscript";

class AutoCompleteContainer extends Component {
    constructor(props) {
        super(props);
        this.autocomplete = null;
        this.state = {
            errorText: "",
            autoCompleted: false,
            address: "",
            location: {},
            selected: false,
        };
    }

    componentDidMount() {
        window.handleCallback = this.handleCallback;
        if (!document.getElementById(gmapScriptId)) {
            const gmapScriptEl = document.createElement(`script`);
            gmapScriptEl.id = gmapScriptId;
            gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${
                process.env.REACT_APP_GOOGLE_API_KEY
            }&libraries=places&callback=handleCallback`;
            document
                .querySelector(`body`)
                .insertAdjacentElement(`beforeend`, gmapScriptEl);
        }
    }

    componentWillUnmount() {
        const gmapScriptEl = document.getElementById(gmapScriptId);
        if (gmapScriptEl) {
            gmapScriptEl.remove();
        }
    }

    handleCallback = () => {
        this.setState({
            autoCompleted: true,
        });
    };

    componentDidUpdate() {}

    handlePlaceChanged() {}

    onError = (status, clearSuggestions) => {
        clearSuggestions();
    };

    handleSelect = async address => {
        try {
            const location = await geocodeByAddress(address);
            const latLng = await getLatLng(location[0]);
            this.setState(
                {
                    location: { lat: latLng.lat, lng: latLng.lng },
                    address,
                    selected: true,
                },
                () => {
                    this.props.onLocationUpdate &&
                        this.props.onLocationUpdate(this.state);
                }
            );
        } catch (error) {
            return;
        }
    };

    handleChange(event) {
        this.setState(
            {
                address: event,
            },
            () => this.handlePlaceChanged()
        );
        // if (this.props.meta.error) {
        //     this.setState({errorText: `${this.props.meta.error}`})
        // } else {
        //    this.setState({errorText: ''})
        // }
    }

    render() {
        return (
            this.state.autoCompleted && (
                <PlacesAutocomplete
                    value={this.state.address}
                    onChange={this.handleChange.bind(this)}
                    onSelect={this.handleSelect}
                    searchOptions={{
                        radius: 15000,
                        // eslint-disable-next-line no-undef
                        location: new google.maps.LatLng(60.192059, 24.945831),
                        types: this.props.tenant ? undefined : ["address"],
                        componentRestrictions: { country: "fi" },
                    }}
                    googleCallbackName="handleCallback"
                    onError={this.onError}
                >
                    {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                    }) => (
                        <div>
                            <TextField
                                {...getInputProps({
                                    placeholder: this.props.input.value
                                        ? this.props.input.value
                                        : "Enter your address",
                                    className: "location-search-input",
                                })}
                                style={{ width: "100%" }}
                            />
                            <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                        ? "suggestion-item--active"
                                        : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? {
                                              backgroundColor: "#fafafa",
                                              cursor: "pointer",
                                          }
                                        : {
                                              backgroundColor: "#ffffff",
                                              cursor: "pointer",
                                          };
                                    return (
                                        <div
                                            key={suggestion.placeId}
                                            {...getSuggestionItemProps(
                                                suggestion,
                                                {
                                                    className,
                                                    style,
                                                }
                                            )}
                                        >
                                            <span>
                                                {suggestion.description}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                            {this.state.selected ? (
                                <h2 style={{ marginTop: 40 }}>
                                    You have selected {this.state.address}
                                </h2>
                            ) : null}
                        </div>
                    )}
                </PlacesAutocomplete>
            )
        );
    }
}

// AutoCompleteContainer.propTypes = {
//     name: propTypes.string.isRequired,
//     onPlaceChanged: propTypes.func,
//     // addEventLocation: propTypes.func.isRequired
// }

function mapStateToProps(state, props) {
    return {};
}

function mapDispatchToProps(dispatch, props) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoCompleteContainer);
